import { render } from "./ContactUs.vue?vue&type=template&id=24e58e02&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=24e58e02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e58e02"]])

export default __exports__